// Super Admin Comment — staff-only note on a booking. Lifted out of order.js so the
// order modal and the Rated Orders case modal share one write path:
// bookings/{id}.superAdminComment + a superAdminComment log entry (rendered by Logs.js).
import React, { useEffect, useState } from 'react';
import { Button, Input } from 'reactstrap';
import { ORDER_COLLECTION } from '../../../../config/env';
import { firestore } from '../../../../helpers/Firebase';
import { accessTypes, accessTypesObject, createNotification } from '../../../../helpers/Utils';

const SuperAdminComment = ({ booking, user, title = 'Super Admin Comment', onSaved, style }) => {
  const id = booking?.key || booking?.id || booking?.bookingId;
  const [comment, setComment] = useState(booking?.superAdminComment || '');
  const [saving, setSaving] = useState(false);
  useEffect(() => { setComment(booking?.superAdminComment || ''); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!accessTypes.includes(user?.accessType) || !id) return null;

  const save = async () => {
    const text = String(comment || '').trim();
    if (!text) return;
    setSaving(true);
    const now = Date.now();
    try {
      await firestore().collection(ORDER_COLLECTION).doc(id).update({ superAdminComment: text });
      await firestore().collection('logs').doc(id).set({
        data: firestore.FieldValue.arrayUnion({
          title: 'superAdminComment', created: now,
          createdBy: accessTypesObject?.[user?.accessType]?.name, createdByName: user?.displayName, comment: text,
        }),
        updated: now,
      }, { merge: true }).catch((error) => console.error('superAdminComment log failed', error));
      createNotification('success', 'Your comment is added successfuly', 'Success');
      onSaved && onSaved(text);
    } catch (error) {
      console.error('Error writing document: ', error);
      createNotification('error', error?.message || 'Could not save the comment', 'Error');
    } finally { setSaving(false); }
  };

  return (
    <div style={style}>
      {title ? <h6>{title}</h6> : null}
      <Input type="textarea" placeholder="Add your comments here" value={comment} onChange={(e) => setComment(e.target.value)} />
      <Button disabled={saving || !String(comment || '').trim() || String(comment || '').trim() === (booking?.superAdminComment || '')}
        className="mt-2 top-right top-right-button" size="sm" color="primary" outline onClick={save}>
        {saving ? 'Saving…' : 'Save Comment'}
      </Button>
    </div>
  );
};

export default SuperAdminComment;
